import { render, staticRenderFns } from "./OwnerSettlementPending.vue?vue&type=template&id=b18116f2&"
import script from "./OwnerSettlementPending.vue?vue&type=script&lang=js&"
export * from "./OwnerSettlementPending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports